import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import '@mutiblelite/ui/theme.css'
import App from './App.vue'
import HomeView from './views/HomeView.vue'
import FeaturesView from './views/FeaturesView.vue'
import DownloadView from './views/DownloadView.vue'
import PurchaseView from './views/PurchaseView.vue'
import HelpView from './views/HelpView.vue'
import PrivacyView from './views/PrivacyView.vue'
import './site.css'

const basePath = import.meta.env.BASE_URL

const router = createRouter({
  history: createWebHistory(basePath),
  routes: [
    { path: '/', component: HomeView, meta: { title: '首页' } },
    { path: '/features', component: FeaturesView, meta: { title: '功能' } },
    { path: '/download', component: DownloadView, meta: { title: '下载' } },
    { path: '/purchase', component: PurchaseView, meta: { title: '购买与激活' } },
    { path: '/help', component: HelpView, meta: { title: '激活帮助' } },
    { path: '/privacy', component: PrivacyView, meta: { title: '隐私与许可' } },
  ],
  scrollBehavior: () => ({ top: 0 }),
})

router.afterEach((route) => {
  document.title = `${String(route.meta.title)}｜发多多`
})

createApp(App).use(router).mount('#app')
